import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
//
import asyncComponent from 'util/asyncComponent';
import ErrorPage404 from 'routes/errorPages/404';

const Lms = ({ match }) => (
  <Switch>
    <Redirect exact from={`${match.url}/`} to={`${match.url}/courses`} />
    <Route
      exact
      path={`${match.url}/categories`}
      component={asyncComponent(() => import('./Categories'))}
    />
    <Route
      exact
      path={`${match.url}/courses`}
      component={asyncComponent(() => import('./Courses'))}
    />
    <Route
      exact
      path={`${match.url}/courses/:id(\\d+)`}
      component={asyncComponent(() => import('./Courses/Editor'))}
    />
    <Route
      exact
      path={`${match.url}/assignments`}
      component={asyncComponent(() => import('./Assignments'))}
    />
    <Route
      exact
      path={`${match.url}/assignments/new`}
      component={asyncComponent(() => import('./Assignments/Create'))}
    />
    <Route
      exact
      path={`${match.url}/assignments/:id(\\d+)`}
      component={asyncComponent(() => import('./Assignments/Detail'))}
    />
    <Route
      exact
      path={`${match.url}/certificates`}
      component={asyncComponent(() => import('./Certificates'))}
    />
    <Route path='*' exact component={ErrorPage404} />
  </Switch>
);
Lms.propTypes = {
  match: PropTypes.object
};
export default Lms;
